// export const organization = {
//   routes: [
//     {
//       path: "/organization/file-manager",
//       component: () => import("../file-manager-view"),
//     },
//   ],
// };

export const fwsed = {
  routes: [
    {
      path: "/fwsed/file-manager",
      component: () => import("../fwsed-file-manager-view"),
    },
  ],
};
export const risk = {
  routes: [
    {
      path: "/risk/file-manager",
      component: () => import("../risk-file-manager-view"),
    },
  ],
};
export const auditControl = {
  routes: [
    {
      path: "/audit-control/file-manager",
      component: () => import("../audit-control-file-manager-view"),
    },
  ],
};
export const finding = {
  routes: [
    {
      path: "/finding/file-manager",
      component: () => import("../finding-file-manager-view"),
    },
  ],
};
